import { GQL_ID } from '@@types'
import { gql, useMutation } from '@apollo/client'

interface ChoosePaymentMethodForOrderVariables {
  paymentMethodId: GQL_ID
  orderId: GQL_ID
  useAsDefault?: boolean
}

interface ChoosePaymentMethodForOrderResponse {
  choosePaymentMethodForOrder: {
    paymentMethod: {
      id: GQL_ID
      isDefault: boolean
    }
    affectedOrdersAmount: number
  }
}

export const GQL_MUTATION_CHOOSE_PAYMENT_METHOD_FOR_ORDER = gql`
  mutation choosePaymentMethodForOrder(
    $paymentMethodId: ID!
    $orderId: ID!
    $useAsDefault: Boolean
  ) {
    choosePaymentMethodForOrder(
      paymentMethodId: $paymentMethodId
      orderId: $orderId
      useAsDefault: $useAsDefault
    ) {
      paymentMethod {
        id
        isDefault
      }
      affectedOrdersAmount
    }
  }
`

export const useMutateChoosePaymentMethodForOrder = () =>
  useMutation<
    ChoosePaymentMethodForOrderResponse,
    ChoosePaymentMethodForOrderVariables
  >(GQL_MUTATION_CHOOSE_PAYMENT_METHOD_FOR_ORDER)
